import { getScrollTop, getScrollEventTarget, scrollContainerMediaQuery } from '@theme/scroll-container';

if (document.body.classList.contains('zr-member-page')) {
  let frame = null;
  let scrollTarget = null;

  const recoverAtTop = () => {
    frame = null;
    if (document.hidden || !document.body.classList.contains('zr-member-page')) return;
    const header = document.querySelector('#header-component');
    if (!header?.isConnected || header.getAttribute('sticky') !== 'scroll-up') return;
    if (header.dataset.stickyState !== 'idle' || header.dataset.scrollDirection === 'down') return;
    const scrollTop = getScrollTop();
    if (!Number.isFinite(scrollTop) || scrollTop > 1 || header.getBoundingClientRect().top < -1) return;
    if (header.querySelector('header-drawer details[open], header-drawer .menu-open, header-menu [aria-expanded="true"]')) return;
    header.dataset.stickyState = 'inactive';
    header.dataset.scrollDirection = 'none';
  };

  const schedule = () => {
    if (frame !== null) return;
    frame = requestAnimationFrame(() => {
      frame = requestAnimationFrame(recoverAtTop);
    });
  };

  const onScroll = () => {
    if (getScrollTop() <= 1) schedule();
  };

  const bindScroll = () => {
    const next = getScrollEventTarget();
    if (next === scrollTarget) return;
    scrollTarget?.removeEventListener('scroll', onScroll);
    scrollTarget = next;
    scrollTarget.addEventListener('scroll', onScroll, { passive: true });
  };

  const onLayoutChange = () => {
    bindScroll();
    schedule();
  };

  scrollContainerMediaQuery.addEventListener('change', onLayoutChange);
  document.addEventListener('toggle', event => {
    if (event.target instanceof Element && event.target.closest('header-drawer') && !event.target.open) schedule();
  }, true);
  document.addEventListener('transitionend', event => {
    if (event.propertyName === 'opacity' && event.target === document.querySelector('#header-component')) schedule();
  });
  document.addEventListener('shopify:section:load', onLayoutChange);
  window.addEventListener('pageshow', onLayoutChange);
  bindScroll();
  schedule();
}
